<template>
  <div class="table_content">
    <div class="user_table">
      <el-table
        ref="table"
        size="small"
        height="100%"
        header-cell-class-name="brand-table-header-cell"
        cell-class-name="brand-table-cell"
        v-loading="loading"
        :data="userList"
      >
        <el-table-column prop="userName" label="账号名" width="100">
        </el-table-column>
        <el-table-column label="手机号码" prop="phone"> </el-table-column>
        <el-table-column label="邮箱" prop="email"> </el-table-column>
        <!-- <el-table-column label="邀请码" prop="invitationCode"> </el-table-column> -->
        <el-table-column label="微信昵称" prop="nickName"> </el-table-column>
        <el-table-column label="企业" prop="enterpriseName"> </el-table-column>
        <el-table-column label="有效期" prop="indate" :formatter="formaterTime">
        </el-table-column>
        <el-table-column
          label="更新时间"
          prop="updateTime"
          :formatter="formaterTime"
        ></el-table-column>
        <el-table-column
          label="添加时间"
          prop="createTime"
          :formatter="formaterTime"
        ></el-table-column>
        <el-table-column label="操作" :width="120">
          <template v-slot="scope">
            <el-button
              class="no-margin center-children"
              type="text"
              size="small"
              @click="toEdit(scope.row)"
              >编辑</el-button
            >
            |
            <el-popconfirm title="确定删除吗？" @confirm="toDel(scope.row)">
              <el-button
                slot="reference"
                class="no-margin center-children"
                type="text"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagination" class="pagination">
      <el-pagination
        :current-page="params.page"
        :page-size="params.size"
        :total="params.total"
        layout="total, prev, pager, next"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 列表数据
    userList: {
      type: Array,
      default: () => [],
    },
    // 分页器数据
    params: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 10,
          total: 0,
        };
      },
    },
    // 是否加载中
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changePage(page) {
      this.$emit("change-page", page);
    },
    formaterTime(row, column, cellValue, index) {
      if (row.userStatus === 1 && column.property === "indate") {
        return "永久";
      }
      const newTime = this.$moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return newTime;
    },
    // 跳转编辑弹窗
    toEdit(row) {
      //   console.log("您点击了编辑");
      this.$emit("edit-user", row);
    },
    // 点击删除触发事件
    toDel(row) {
      //   console.log("您点击了删除", row);
      this.$http({
        url: `/user/delete?userId=${row.userId}`,
        method: "delete",
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除账号成功",
              type: "success",
            });
            if (this.userList.length === 1 && this.params.page !== 1) {
              this.$emit("change-page", this.params.page - 1);
            } else {
              this.$emit("update");
            }
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "删除账号失败",
            type: "error",
          });
        });
    },
  },
};
</script>


<style lang="scss">
.no-margin {
  margin: 0;
}
.center-children {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.pagination {
  text-align: right;
}
.table_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  .user_table {
    flex: 1;
    height: 0;
  }
  .pagination {
    height: 32px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/accManage/userTable.vue